function initGallerySliders() {
  var galleryImages = document.querySelectorAll('.blocks__gallery');

  galleryImages.forEach(function(gallery) {
    var imageContainer = gallery.querySelector('.blocks__gallery ul');
    var leftArrow = gallery.querySelector('.blocks__gallery__arrow--left');
    var rightArrow = gallery.querySelector('.blocks__gallery__arrow--right');
    var images = imageContainer.querySelectorAll('li');

    function updateArrows() {
      var activeIndex = Array.from(images).findIndex(li => li.classList.contains('active'));
      leftArrow.classList.toggle('disabled', activeIndex === 0);
      rightArrow.classList.toggle('disabled', activeIndex === images.length - 1);
    }

    rightArrow.addEventListener('click', function() {
      var currentImage = imageContainer.querySelector('li.active');
      var nextImage = currentImage.nextElementSibling;
      if (nextImage) {
        var nextImagePosition = nextImage.offsetLeft;
        imageContainer.scrollTo({ left: nextImagePosition, behavior: 'smooth' });
        currentImage.classList.remove('active');
        nextImage.classList.add('active');
        updateArrows();
      }
    });

    leftArrow.addEventListener('click', function() {
      var currentImage = imageContainer.querySelector('li.active');
      var prevImage = currentImage.previousElementSibling;
      if (prevImage) {
        currentImage.classList.remove('active');
        prevImage.classList.add('active');
        var prevImagePosition = prevImage.offsetLeft;
        imageContainer.scrollTo({ left: prevImagePosition, behavior: 'smooth' });
        updateArrows();
      }
    });

    // Initialize: set first image active if none, and update arrows
    if (!imageContainer.querySelector('li.active') && images.length) {
      images[0].classList.add('active');
    }
    updateArrows();
  });
}

// Usage: call initGallerySliders() after your fetch completes and DOM is updated
initGallerySliders();